import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import helperNumber from "../../../helpers/numbers";
import TitleBar from "../../partials/content/TitleBar";
import pledges from "./Pledges";
import StatusPledge from "./StatusPledge";

function Pledge() {
  const generatePledgeTable = () => {
    return (
      <>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین شما از
                موجودی حساب شما کسر میشود.
              </p>
            </li>
            <li>
              <p className="text-justify">
                یک سوم مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان
                بیعانه در زمان درج کمپین از موجودی حساب شما کسر میگردد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما بازگردانده
                خواهد شد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما بازگشت
                داده نخواهد شد.
              </p>
            </li>
          </ul>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space table-hover m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>مبلغ (تومان)</td>
                <td>نام کمپین</td>
                <td>وضعیت</td>
                <td>تاریخ اخذ</td>
                <td>تاریخ بازگشت</td>
              </tr>
            </thead>
            <tbody>
              {pledges.map((item, key) => {
                return (
                  <tr key={item.id}>
                    <td>{helperNumber.toPersianNum(key + 1)}</td>
                    <td>{helperNumber.toPersianNum(item.id)}</td>
                    <td className="number-finance">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(item.amount)
                      )}
                    </td>
                    <td>{item.campaign}</td>
                    <td>
                      <span
                        className={`badge 
               ${
                 item.status === StatusPledge.statusPledge.BLOCK
                   ? "badge-danger"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GET
                   ? "badge-warning"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GIVE
                   ? "badge-success"
                   : ""
               } 
            `}
                      >
                        {StatusPledge.statusPledgeString()[item.status]}
                      </span>
                    </td>
                    <td>{helperNumber.toPersianNum(item.created_at)}</td>
                    <td>
                      {item.returned_at !== null
                        ? helperNumber.toPersianNum(item.returned_at)
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="all-pledge" />

      <div className="content-wrapper">
        <TitleBar title="لیست بیعانه   " />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generatePledgeTable()}</div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Pledge;
